import type { FC } from 'react';
import React, { useContext, useState } from 'react';

import { RicosContext } from './../../../ricos-context';
import type { IToolbarItem } from './../../../ricos-types';
import { ToggleButton } from './../../../toolbars-ui';

import { BGColorIcon } from '../../icons';
import { useColorPickerModal } from '../../modals/use-color-picker-modal';

interface Props {
  toolbarItem: IToolbarItem;
  dataHook?: string;
}

export const BackgroundColorButton: FC<Props> = ({ dataHook, toolbarItem }) => {
  const { t } = useContext(RicosContext);
  const [referenceElement, setReferenceElement] = useState<HTMLDivElement | null>(null);

  const colorPickerModal = useColorPickerModal();

  return (
    <ToggleButton
      setRef={setReferenceElement}
      Icon={BGColorIcon}
      onClick={() =>
        colorPickerModal.toggleModal(referenceElement, {
          color: toolbarItem.attributes.backgroundColor,
          onChange: color => toolbarItem.commands.click({ backgroundColor: color }),
        })
      }
      dataHook={dataHook}
      tooltip={t('TablePlugin_Toolbar_BGColor_Tooltip')}
    />
  );
};
